import React from 'react';
import { AwardCardProps } from '../types';

const AwardCard: React.FC<AwardCardProps> = ({ card }) => {
  return (
    <div className="flex flex-col items-center mx-4 mt-10 mb-24 pb-4 sm:m-4 sm:mb-8 p-2 bg-white rounded-lg shadow-md">
      <div className="my-5 text-lg font-semibold text-font-500">
        {card.year}
      </div>

      <div className="flex items-center justify-center px-2 w-full">
        <img
          width="36"
          height="139"
          className="lazyload"
          src="https://assets.clear.in/cleartax/images/1751982055_group18142181101.png"
          alt=""
          loading="lazy"
        />
        <div className="text-sm flex-1 text-center px-4">{card.title}</div>
        <img
          width="36"
          height="139"
          className="lazyload"
          src="https://assets.clear.in/cleartax/images/1751982110_group1814218109.png"
          alt=""
          loading="lazy"
        />
      </div>

      <div className="text-center my-5 text-sm">{card.description}</div>
    </div>
  );
};

export default AwardCard;
